import React, { useState, useMemo, useEffect, useCallback } from 'react';
import TextEditorView from '../view/TextEditorView';
import { createEditorStateWithText } from 'draft-js-plugins-editor';
import createToolbarPlugin from 'draft-js-static-toolbar-plugin';
import {
  EditorState,
  ContentState,
  convertFromHTML,
  convertToRaw,
  Modifier
} from 'draft-js';
import draftToHtml from 'draftjs-to-html';

import { decorator } from '../HyperLink4TextEditor';

const TextEditorEngine = ({
  editorHeight = 300,
  editorText = '',
  onChange = v => v,
  fieldsPlaceholders,
  additionalPlaceHolders,
  additionalPlaceHoldersProps
}) => {
  const [editorState, setEditorState] = useState(
    createEditorStateWithText(editorText)
  );

  useEffect(() => {
    const value = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    onChange(value);
  }, [editorState]);

  useEffect(() => {
    if (editorText.trim().length) {
      const hackedText = `<div><p> ${editorText
        .replace(/<\/p>/gi, '<br>')
        .replace(/<p>/gi, '')
        .replace(/<ins>/gi, '<u>')
        .replace(/<\/ins>/gi, '</u>')} </p></div>`;

      const blocksFromHTML = convertFromHTML(hackedText);
      const content = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      setEditorState(EditorState.createWithContent(content, decorator));
    }
  }, []);

  const [editorEl, setEditorEl] = useState(null);

  const toolbarPlugin = useMemo(() => createToolbarPlugin(), []);

  const insertPlaceHolder = useCallback(
    value => {
      const placeHolder = `\${${value}}`;

      const newContentState = Modifier.insertText(
        editorState.getCurrentContent(), // get ContentState from EditorState
        editorState.getSelection(),
        placeHolder
      );

      const newState = EditorState.createWithContent(
        newContentState,
        decorator
      );
      const nextOffSet =
        editorState.getSelection().getFocusOffset() + placeHolder.length;

      const newSelection = editorState.getSelection().merge({
        focusOffset: nextOffSet,
        anchorOffset: nextOffSet
      });

      setTimeout(() => {
        setEditorState(EditorState.forceSelection(newState, newSelection));
      }, 1);
    },
    [editorState]
  );

  useEffect(() => {
    function get_nodes_containing_text(selector, text) {
      const elements = [...document.querySelectorAll(selector)];

      return elements.filter(
        element =>
          element.childNodes[0] &&
          element.childNodes[0].nodeValue &&
          RegExp(text).test(element.childNodes[0].nodeValue.trim())
      );
    }

    let nodeArr = get_nodes_containing_text(
      'span',
      'list of submissions end - enter field placeholders above this line'
    );

    if (nodeArr && nodeArr.length) {
      let node = nodeArr[0];
      node.style.backgroundColor = '#DAE1F2';
      node.style.color = 'darkgray';
      node.contentEditable = 'false';
    }

    nodeArr = get_nodes_containing_text(
      'span',
      'list of submissions start - enter field placeholders below this line'
    );

    if (nodeArr && nodeArr.length) {
      let node = nodeArr[0];
      node.style.backgroundColor = '#DAE1F2';
      node.style.color = 'darkgray';
      node.contentEditable = 'false';
    }
  });

  const viewProps = {
    editorState,
    setEditorState,
    plugins: [toolbarPlugin],
    toolbarPlugin,
    editorEl,
    setEditorEl,
    editorHeight,
    fieldsPlaceholders,
    insertPlaceHolder,
    additionalPlaceHolders,
    additionalPlaceHoldersProps
  };

  return <TextEditorView {...viewProps} />;
};

export default TextEditorEngine;
